
import * as defaultImport from "@splunk/react-ui/Resize";
export * from "@splunk/react-ui/Resize";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
